import { render, staticRenderFns } from "./dispatching-credits.vue?vue&type=template&id=7345042c"
import script from "./dispatching-credits.vue?vue&type=script&lang=ts"
export * from "./dispatching-credits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports